// extracted by mini-css-extract-plugin
export default {"container":"CategoryPage_container__krSUn","item":"CategoryPage_item__ZhU1N"};